export default "__VITE_ASSET__DgeOnO1T__"